var InputClass = (function () {
    function InputClass() {
    }
    return InputClass;
}());
//# sourceMappingURL=InputClass.js.map